import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'attributeValue',
    serviceName: 'shopadmin',
    query: gql`
      query attributeValue($ids: [String]) {
        attributeValue(ids: $ids) {
          data {
            title
            details
            attribute {
              id
            }
          }
        }
      }
    `,
  },
  update: {
    name: 'updateAttributeValue',
    serviceName: 'admin',
    query: gql`
      mutation updateAttributeValue($ids: [String]!, $title: String!, $attribute_id: String, $details: String) {
        updateAttributeValue(ids: $ids, title: $title, attribute_id: $attribute_id, details: $details) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
